module.exports = __webpack_public_path__ + "media/images/emblems/Lonay-coat_of_arms-0feae5c32581f31af0ca32f03f25f949.svg";